import React, {useState} from "react";
import {FAQS} from "../../data/siteData";
import ContactText from "../common/ContactText";
import Icon from "../common/Icon";

const FaqSection = () => {
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <section className="pb-container" style={{padding: '84px 24px 0'}}>
            <div className="pb-faq-card">
                <div>
                    <p className="pb-pill" style={{background: 'rgba(11,114,201,0.12)', color: '#0B72C9'}}>Frequently asked</p>
                    <h2 className="pb-faq-title">Questions we get a lot</h2>
                    <p className="pb-faq-lead">Everything else people ask before their first paddle.</p>
                    <div className="pb-faq-bubbles">
                        <span style={{background: '#0B72C9'}}>?</span>
                        <span className="is-big" style={{background: '#96298E'}}>?</span>
                        <span style={{background: '#F47B20'}}>?</span>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    {FAQS.map((f, i) => {
                        const open = openIndex === i;
                        const color = open ? '#0B72C9' : '#101f3a';
                        return (
                            <div key={f.q} className="pb-faq-item">
                                <button onClick={() => setOpenIndex(open ? -1 : i)} aria-expanded={open}
                                        className="pb-faq-question" style={{color}}>
                                    {f.q}
                                    <span className="pb-chevron" style={{color, transform: open ? 'rotate(180deg)' : 'none'}}>
                                        <Icon name="chev" size={18}/>
                                    </span>
                                </button>
                                {open && <p className="pb-faq-answer"><ContactText text={f.a}/></p>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
